/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HFlow, ModalFooter, ModalFooterButton, Text, useTheme } from 'bold-ui'
import { resolveName } from 'components/form'
import { IconLabel } from 'components/IconLabel'
import { useField } from 'react-final-form'
import { MetaRoot } from 'util/metaPath'

import { getPerguntaAtivaInfo } from '../consulta-seguimento-aplicacao/utils-consultaSeguimentoAplicacao'
import { ConsultaSeguimentoFieldModel, ConsultaSeguimentoModalTab } from '../model-consultaSeguimento'
import { ConsultaSeguimentoModalFooterCounter } from './ConsultaSeguimentoModalFooterCounter'

interface ConsultaSeguimentoModalFooterProps {
  name: MetaRoot<ConsultaSeguimentoFieldModel>
  currentTab: ConsultaSeguimentoModalTab
  isMChatRiscoBaixo: boolean
  startFailed: boolean
  onStart: () => void
  onGoToNextQuestion: () => void
  onCloseModal: () => void
}

export function ConsultaSeguimentoModalFooter(props: Readonly<ConsultaSeguimentoModalFooterProps>) {
  const { name, currentTab, isMChatRiscoBaixo, startFailed, onStart, onGoToNextQuestion, onCloseModal } = props

  const theme = useTheme()

  const {
    input: { value: aplicacao },
    meta: { error = {} },
  } = useField(resolveName(name.aplicacao), { subscription: { value: true, error: true } })

  const { perguntaAtiva, isLast: isLastPergunta } = getPerguntaAtivaInfo(aplicacao)
  const isInvalid = perguntaAtiva in error

  return (
    <ModalFooter>
      <HFlow alignItems='center' justifyContent='space-between'>
        <Text color='secondary' style={styles.authorsLabel}>
          © 2009 Robins, Fein, & Barton
        </Text>

        <HFlow justifyContent='flex-end' alignItems='center'>
          {currentTab === ConsultaSeguimentoModalTab.RESULTADO && (
            <IconLabel
              icon='checkCircleOutline'
              text='Resultado salvo no atendimento'
              color={theme.pallete.status.success.c40}
            />
          )}

          {currentTab === ConsultaSeguimentoModalTab.SELECAO && (
            <ConsultaSeguimentoModalFooterCounter
              name={name.perguntasSelecionadas}
              isMChatRiscoBaixo={isMChatRiscoBaixo}
              startFailed={startFailed}
            />
          )}

          <ModalFooterButton onClick={onCloseModal}>
            {currentTab === ConsultaSeguimentoModalTab.RESULTADO ? 'Fechar' : 'Cancelar'}
          </ModalFooterButton>

          {currentTab === ConsultaSeguimentoModalTab.SELECAO && (
            <ModalFooterButton kind='primary' onClick={onStart}>
              Iniciar
            </ModalFooterButton>
          )}

          {currentTab === ConsultaSeguimentoModalTab.APLICACAO && (
            <ModalFooterButton kind='primary' onClick={onGoToNextQuestion} disabled={isInvalid}>
              {isLastPergunta ? 'Calcular resultado' : 'Continuar'}
            </ModalFooterButton>
          )}
        </HFlow>
      </HFlow>
    </ModalFooter>
  )
}

const styles = {
  authorsLabel: css`
    padding-left: 1rem;
  `,
}
